interface EmptyItemProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

export function EmptyItem({ title, description, icon }: EmptyItemProps) {
  return (
    <article
      data-cy='empty-message'
      className='flex flex-col m-auto max-w-[328px] items-center justify-center min-h-[400px] text-center'
    >
      <span className='mb-4'>{icon}</span>
      <h2 className='text-2xl font-semibold text-white mb-2'>{title}</h2>
      <p className='text-zinc-400'>{description}</p>
    </article>
  );
}
